import React, { useState, useEffect, useRef } from "react";
import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { NavButtonModel } from "../Models/NavButtonModel";
import NavDropdownItem from "../NavDropdownItem/NavDropdownItem";

import "./NavButton.css";

interface NavDropdoenItemProps {
  blok: NavButtonModel;
  onClick?: () => void;
}
const NavButton: React.FC<NavDropdoenItemProps> = ({ blok, onClick }) => {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const navDropdownContainerRef = useRef<HTMLDivElement | null>(null);

  let [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(!clicked);
    if (blok.navDropdown?.length < 1 && onClick) {
      onClick();
    }
  };
  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setClicked(false);
    }
  };
  const handleItemClick = () => {
    if (navDropdownContainerRef.current) {
      navDropdownContainerRef.current.classList.add("hide");
      setTimeout(() => {
        if (navDropdownContainerRef.current) {
          navDropdownContainerRef.current.classList.remove("hide");
        }
      }, 1);
    }
    if (onClick) {
      onClick();
    }
    setClicked(!clicked);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  const button = blok.button[0];
  const showOpenClass =
    window.innerWidth < 480 && clicked && blok.navDropdown?.length > 0;
  const showDropDown =
    blok.type !== "lastButton" &&
    ((window.innerWidth < 480 && clicked) || window.innerWidth >= 480) &&
    blok.navDropdown?.length > 0;

  return (
    <div
      className={`nav-button-container ${showOpenClass ? "open" : ""}`}
      {...storyblokEditable(blok)}
      ref={menuRef}
    >
      <StoryblokComponent
        blok={button}
        key={button._uid}
        onButtonClick={handleClick}
      />

      {showDropDown && (
        <div
          ref={navDropdownContainerRef}
          className={`nav-dropdown-container ${showOpenClass ? "open" : ""} ${
            blok.navDropdown.length < 4 ? "center" : ""
          }`}
        >
          <div className="row">
            {blok.navDropdown.map((butt) => (
              <NavDropdownItem
                blok={butt}
                onClick={handleItemClick}
                key={butt._uid}
              ></NavDropdownItem>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NavButton;
